<template>
  <div class="ma-2 ml-3">
    <comboFarm
     @fromFarm="farmInfo"
    />
    <!-- {{ this.$getters }} -->
    <!-- {{ farmData }} -->
    <!-- {{ services }} -->

    <div class="main">
      <div class="basic-container mt-2">
        <div class="sensor">
          <div class="title" v-if="sensorloading">
            <div class="title_text">환경지표</div>
            <div class="title_line"></div>
          </div>

          <div v-if="sensorloading" class="base-loading-container flex-center" >
            <div class="spinner"></div>
          </div>

          <div v-if="!sensorloading">
            <v-carousel
              :continuous="false"
              :show-arrows="false"
              delimiter-icon="mdi-circle"
              class="carousel"
              hide-delimiter-background
            >
              <v-carousel-item v-for="(item, i) in items" :key="i">
                <div>
                  <div class="title" @click="summary()">
                    <div class="title_text">{{item.building_name}}</div>
                    <div class="title_line"></div>
                  </div>

                  <div class="sensor-container vertical-center col" >
                    <div class="sensor_container" >
                      <div v-for="(room, r) in item.room_list" :key="r" class="room_info">
                        <div class="room_name">
                          <div class="room_text"> {{ room.room_name }} </div>
                          <div class="time_text" :class="room.checkTime !== null ? '' : 'red-text'"> 측정시간 {{ room.checkTime }} </div>
                        </div>
                        <div class="sensor_info_container">
                          <div class="sensor_info">
                            <div class="value flex" v-if="room.w_sensor.pressure == null">
                              <div class="value_box">
                                <img :src="icon_temp" class="icon_size"/>
                              </div>

                              <div class="value_text"> {{ room.temp }}</div>
                              <div class="unit">°C</div>
                            </div>

                            <div class="value flex mt-1" v-if="room.w_sensor.pressure == null">
                              <div class="value_box">
                                <img :src="icon_hum" class="icon_size"/>
                              </div>
                              <div class="value_text">{{ room.hum }}</div>
                              <div class="unit"> % </div>
                            </div>

                            <div class="value flex mt-1" v-if="room.co2 !== '-'">
                              <div class="value_box">
                                <img :src="icon_co2" class="icon_size"/>
                              </div>
                              <div class="value_text">{{ room.co2 }}</div>
                              <div class="unit ppm"> ppm </div>
                            </div>


                            <div class="value flex" v-if="room.nh3 !== '-'">
                              <div class="value_box">
                                <img :src="icon_nh3" class="icon_size"/>
                              </div>
                              <div class="value_text">{{ room.nh3 }}</div>
                              <div class="unit ppm"> ppm </div>
                            </div>

                            <div class="value flex" v-if="room.h2s !== '-'">
                              <div class="value_box">
                                <img :src="icon_h2s" class="icon_size"/>
                              </div>
                              <div class="value_text">{{ room.h2s }}</div>
                              <div class="unit ppm"> ppm </div>
                            </div>

                            <div class="value flex" v-if="room.w_sensor.pressure !== null">
                              <div class="value_box">
                                <img :src="icon_press" class="icon_size"/>
                              </div>
                              <div class="value_text">{{ room.w_sensor.pressure }}</div>
                              <div class="unit ppm"> hPa </div>
                            </div>

                            <div class="flex weather-doll" v-if="room.w_sensor.wind.speed !== null">
                              <div class="value_box">
                                <img :src="icon_windy" class="icon_size"/>
                              </div>

                              <div class="value-weather">
                                <div class="flex">
                                  <div class="value_text">{{ room.w_sensor.wind.speed }}</div>
                                  <div class="unit ppm"> m/s </div>
                                </div>

                                <div class="value_text">{{ getdirectionText(room.w_sensor.wind.speed)}}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>

        <div class="weather" @click="weatherSite()">
          <div class="title">
            <div class="title_text">날씨정보</div>
            <div class="title_line"></div>
          </div>

          <div class="weather-container flex vertical-center col">
            <div class="current-container">

              <div class="current-date">
                <div>오늘</div>
                <div>{{ todayDate }}</div>
              </div>


              <div class="flex weather-info">
                <img class="weather-icon" :src="require('@/assets/monitoring/Weather/' + current.weather_icon + '.svg')" />
                <div>{{ current.weather_content }}</div>
              </div>

              <div class="degree-content">
                <div class="cur_info">{{ current.temp }} 
                  <span class="info_unit">°C</span>
                </div>
                <div class="highlow_temp">
                  <span class="blue-text">{{ current.lowest_temp }} </span>
                  <span class="info_unit blue-text">°C</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="red-text">{{ current.highest_temp }}</span>
                  <span class="info_unit red-text">°C</span>
                </div>
              </div>

              <div class="feel-content">
                <div class="small-text mb-1">체감</div>
                <div  class="cur_info">{{ current.feel }} <span class="info_unit">°C</span></div>
              </div>

              <div class="wind-section">
                <div class="wind-content flex">
                  <img :src="icon_windy" class="mr-1 wind_mb_icon" />
                  <div class="cur_info mr-1"> {{ current.wind.speed }} </div>
                  <span class="unit">m/s</span>
                  <span class="ml-2 mr-2 bold-text"> | </span>
                  <div> {{ getdirection(current.wind.deg) }} </div>
                </div>
              </div>

              <div class="press-section mt-1">
                <div class="press-content flex col">
                  <div class="flex">
                    <div class="wind-icon ml-2">
                      <img :src="icon_humi" />
                    </div>
                   
                    <span class="bold-text wind-text ml-1">{{ current.hum }}</span>
                    <span class="unit">%</span>
                  </div>

                  <div class="flex">
                    <div class="wind-icon ml-1">
                      <img :src="icon_press" />
                    </div>
                    <span class="bold-text wind-text ml-1">{{ current.wind.ps }}</span>
                    <span class="unit">hPa</span>
                  </div>

                </div>
              </div>
            </div>

            <div class="forecast-container"> 
              <div class="forecast-content">
                <div v-for="(weather, w) in forecast.slice(0, 6)" :key="w" class="forecast_info col">
                  <div class="date-text">{{ changeWeek(weather.search_date) }}</div>
                  <div class="forecast_icon">
                    <img :src="require('@/assets/monitoring/Weather/' + weather.weather_icon + '.svg')" />
                  </div>
                  <div class="forecast_degree" >
                    <span class="degree_info red-text"> {{ weather.highest_temp }}℃ </span>
                    <span class="degree_info mb-dash"> / </span>
                    <span class="degree_info blue-text"> {{ weather.lowest_temp }}℃ </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dailyrecord-container" v-show="services.trace">
        
        <div class="sell" v-if="this.farmData.no && this.farmData.biz !== 'CF06' ">
          <div class="title" @click="sell()">
            <div class="title_text">월별 출하두수</div>
            <div class="title_line"></div>
          </div>

          <div v-if="shiploading" class="loading-container flex-center">
            <div class="spinner"></div>
          </div>

          <div v-else class="sell-container col vertical-center">
            <div v-if="farmData.biz === 'CF05'">
              <div class="tab-container flex mt-7">
                <div class="tab-content">
                  <button class="tab mr-1" 
                    :class="{ active: selectedShipTab === 'qgrade' }" 
                    @click="selecShipTab('qgrade')">
                    육질
                  </button>
                  <button class="tab"
                    :class="{ active: selectedShipTab === 'wgrade' }" 
                    @click="selecShipTab('wgrade')">
                    육량
                  </button>
                </div>
              </div>
            </div>

            <div class="chart__layout">
              <Chart
                chartType="Line"
                :chartData="lineChartData"
                :chartOptions="lineChartOptions"
                :chartSize="chartSize"
              />
            </div>
          </div>
        </div>

        <div class="sell" v-if="this.farmData.biz == 'CF06'">
          <div class="title" @click="milk()">
            <div class="title_text">일별 착유량</div>
            <div class="title_line"></div>
          </div>

          <div v-if="milkloading" class="loading-container flex-center">
            <div class="spinner"></div>
          </div>

          <div v-else class="sell-container col vertical-center">
            <div class="market_chart_layout chart__layout">
              <Chart
                chartType="Bar"
                :chartData="milkChartData"
                :chartOptions="lineBarOptions"
                :chartSize="chartSize"
              />
            </div>
          </div>
        </div>

        <div class="market" v-if="services.trace" @click="marketSite()">
          <div class="title">
            <div class="flex">
              <div>
                <img :src="this.farmData.biz == 'CF02' ? icon_pig : icon_cow"/>
              </div>
              <div class="title_text">실시간 시장정보</div>
            </div>
            
            <div class="title_line"></div>
          </div>

          <div v-if="marketloading" class="loading-container flex-center">
            <div class="spinner"></div>
          </div>

          <div v-else class="market-container col vertical-center">
            <div class="flex market-info">
              <div class="live-info">
                <div class="flex mb-3">
                  <div class="line mr-1"></div>
                  <div class="market_title"> 전국 </div>
                </div>

                <div class="livecost_info"> 
                  <div v-if="!market.cur_amt" class="market_unit">
                    시장 개장 전입니다. <br/> 해당 정보는 개장 후 확인 가능합니다.
                  </div>

                  <div v-else>
                    <span class="live_cost">{{ market.cur_amt }}</span>
                    <span class="market_unit"> 원/kg </span>
                    <span class="mb-3 market_unit" :class="this.market.cur_fluct < 0 ? 'blue-text':'red-text'">
                      ( 
                        <span class="mb-3" :class="this.market.cur_fluct < 0 ? 'blue-text' : 'red-text'">
                          <span v-if="this.market.cur_fluct < 0">▼ {{ this.market.cur_fluct }}</span>
                          <span v-else>▲ {{ this.market.cur_fluct }}</span>
                        </span>
                      )
                    </span>
                  </div>
                
                  </div>

                  <div class="title_line mb-2 mt-2"></div>

                  <div class="amt_info">
                    <div class="flex s-bt">
                      <div>시작가</div>
                      <div>{{ market.start_amt }} 원</div>
                    </div>

                    <div class="flex s-bt">
                      <div>당일 최고가</div>
                      <div>{{ market.max_amt }} 원</div>
                    </div>

                    <div class="flex s-bt">
                      <div>당일 최저가</div>
                      <div>{{ market.min_amt }} 원</div>
                    </div>
                  </div>
                </div>

                <div class="marketcost-info vertical-center">
                <div class="market_chart_layout chart__layout">
                  <Chart
                    chartType="Bar"
                    :chartData="doubleChart"
                    :chartOptions="lineBarOptions"
                    :chartSize="chartSize"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="esg-container" v-if="services.esg && this.farmData.no">
        <div class="esg" >
          <div class="title" @click="esg()">
            <div class="title_text">온실가스 배출현황</div>
            <div class="title_line"></div>
          </div>

          <div class="tab-container flex">
            <div class="mr-1" style="color:#a0a0a0; font-size:13px;">kgCO2/year</div>

            <div class="tab-content">
              <button class="tab mr-1" 
                :class="{ active: selectedTab === '전체' }" 
                @click="selectTab('전체')">
                전체
              </button>
              <button class="tab"
                :class="{ active: selectedTab === 'KG 당' }" 
                @click="selectTab('KG 당')">
                KG 당
              </button>
            </div>
          </div>

          <div v-if="esgloading" class="loading-container flex-center">
            <div class="spinner"></div>
          </div>


          <div v-else class="ch4-container col vertical-center">
            <div class="ch4-info mt-1 flex">
              <div class="ch4-chart chart__layout">
                <div v-if="this.selectedTab == '전체'" >
                  <Chart
                  chartType="Bar"
                  :chartData="emissionData"
                  :chartOptions="barChartOptions"
                  :chartSize="energychartSize"
                  :height="10"
                />
                </div>

                <div v-else>
                  <Chart
                  chartType="Bar"
                  :chartData="emissionPerKgData"
                  :chartOptions="barChartOptions"
                  :chartSize="energychartSize"
                  :height="10"
                />
                </div>
              </div>
              <!-- <div class="esg-info ml-2">
                <v-icon color="black" size="14" class="mr-1">mdi-check-circle</v-icon>
                <span class="esg-title"> 전년 동기 배출량 </span>

                <div class="flex vertical-center mt-1 mb-esg">
                  <div class="esg-value">
                   <span>{{ addCommas(this.compareCo2) }}</span>
                  </div>
                  <span class="ml-1 ratio-mb" :class="this.ratioco2 < 0 ? 'blue-text' : 'red-text'">
                    <span v-show="this.ratioco2 < 0">▼</span>
                    <span v-show="this.ratioco2 > 0">▲</span>
                    <span>{{ this.ratioco2 }} </span>
                    <span v-show="this.ratioco2 && this.lastWatt !== null ">%</span>
                  </span>
                </div>

                <div class="ml-2 mb-text">
                  <span v-show="this.ratioco2 > 0">더 배출했어요!</span>
                  <span v-show="this.ratioco2 < 0">더 감소했어요 👏</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="energy" v-if="services.esg && this.farmData.kepco">
          <div class="title" @click="energy()">
            <div class="title_text">에너지 사용량</div>
            <div class="title_line"></div>
          </div>

          <div v-if="energyloading" class="loading-container flex-center">
            <div class="spinner"></div>
          </div>

          <div v-else class="energy-container flex col vertical-center">
                <v-carousel
                  :continuous="false"
                  :show-arrows="false"
                  class="energy-carousel"
                  delimiter-icon="mdi-circle"
                  hide-delimiter-background
                >
                  <v-carousel-item v-for="(item, i) in cost" :key="i">
                   
                    <div class="energy-info flex vertical-center">
                      <div class="energy-chart chart__layout">
                        <div v-if="wattChartData[i]" class="energy-chart-layout">
                          
                          <Chart
                            chartType="Line"
                            :chartData="wattChartData[i]"
                            :chartOptions="lineEnergyOptions"
                            :chartSize="energychartSize"
                            :height="1"
                          />
                        </div>
                      </div>
                      
                      <div class="cost-info ml-3">
                        <div class="kepco-number">
                          <v-icon color="black" size="14">mdi-chevron-double-right</v-icon>
                          <span style="letter-spacing: -1px"> {{ item.kepco_no }} </span>
                        </div>

                        <div class="cost-content mb-cost-mr">
                          <div >
                            <v-icon color="black" size="14" class="mr-1">mdi-check-circle</v-icon>
                            <span class="esg-title"> 이번달 예상 청구금액</span>
                          </div>

                          <div>
                            <span class="esg-value">
                              <span class="mb-cost">{{ addCommas(item.est_charge_fee) }}</span>
                            </span>
                            <span class="ml-2">원</span>
                          </div>
                        </div>
 
                         <div class="cost-content mt-1">
                          <div>
                            <v-icon color="black" size="14" class="mr-1">mdi-check-circle</v-icon>
                            <span class="esg-title cost-font"> 전년 동월 사용량 </span>
                          </div>

                          <div class="flex vertical-center mt-1 mb-esg">
                            <div class="esg-value">
                              <span>{{ addCommas(wattChartData[i]?.compareWatt) }}
                                <span style="font-size:14px; font-weight:400;" v-show="wattChartData[i]?.ratioWatt !== '사용량 없음'">kwh</span>
                              </span>
                            </div>
                            <span class="ml-1 ratio-mb" :class="wattChartData[i]?.ratioWatt < 0 ? 'blue-text' : 'red-text'" v-show="wattChartData[i]?.ratioWatt !== '사용량 없음'">
                              <span v-show="wattChartData[i]?.ratioWatt < 0">▼</span>
                              <span v-show="wattChartData[i]?.ratioWatt > 0">▲</span>
                              <span>{{ wattChartData[i]?.ratioWatt }}</span>
                              <span>%</span>
                            </span>
                          </div>

                          <div class="ml-2 mb-text">
                            <span v-show="wattChartData[i]?.ratioWatt > 0">더 사용했어요!</span>
                            <span v-show="wattChartData[i]?.ratioWatt < 0">더 감소했어요 👏</span>
                          </div>

                        </div>
                      </div> 

                    </div>
                  </v-carousel-item>
                </v-carousel>
              </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

import comboFarm from "@/components/combo/farm.vue";

import Chart from "@/components/chart/Chart.vue"
import { barChartOptions, lineTolineOptions, lineChartOptions, lineBarOptions, dashEnergyOptions } from "@/components/chart/option.js";  // 옵션 불러오기

export default {
  name: 'Home',
  components:{
    comboFarm,
    Chart
  },
  props:{
    farm : {
      type: Object,
    },
  },
  computed: {
    todayDate(){
      return this.today.toLocaleDateString('ko-KR', {
        month: '2-digit',
        day: '2-digit'
      }).replace(/\. /g, '.').slice(0, -1); // 날짜 형식에서 불필요한 공백 제거
    },
  },
  watch:{
    farmData: {
      handler() {
        this.refresh();
      },
      deep: true // farmData 내부의 객체 속성 변화도 감지
    },
    // '$getters.isLogin'(newVal) {
    //   if (newVal) { 
    //     this.typeSeriveUser();  
    //   }
    // },
    selectedTab(newVal, oldVal) {
      if (newVal !== oldVal) this.chartEsg();
    },
    selectedShipTab(newVal, oldVal) {
      if (newVal !== oldVal) this.monthShipData();
    },
  },
  data(){
    return{
      icon_temp: require("@/assets/monitoring/icon/Temperature_small.svg"),
      icon_hum: require("@/assets/monitoring/icon/hum_small.svg"),
      icon_co2: require("@/assets/monitoring/icon/co2_small.svg"),
      icon_nh3: require("@/assets/monitoring/icon/nh3.svg"),
      icon_h2s: require("@/assets/monitoring/icon/h2s.svg"),
      icon_windy: require("@/assets/monitoring/icon/windy_dash.svg"),
      icon_humi: require("@/assets/monitoring/icon/humi_dash.svg"),
      icon_press: require("@/assets/monitoring/icon/press_dash.svg"),
      icon_pig: require("@/assets/pig_icon.svg"),
      icon_cow: require("@/assets/cow_icon.svg"),

      barChartOptions:barChartOptions,
      lineTolineOptions:lineTolineOptions,
      lineChartOptions:lineChartOptions,
      lineBarOptions:lineBarOptions,
      lineEnergyOptions:dashEnergyOptions,

      selectedShipTab:'qgrade',
      Milkitems:[],
      milkData:{},
      milkChartData:{},
      
      chartSize: {
        height:'18vh',
        width: '100%',
      },
      energychartSize:{
        height:'15vh',
        width: '100%',
      },

      items:[],
      current: { wind:{speed:''}},
      forecast : [],

      services:{ },
      monthItems:[],
      lineChartData:{ },
      doubleChart:{ },

      market:[],
			result:'',
			liveinfo:[],
			marketData:{ hhmm:[], auctAmt:[] },


      today:new Date(),
      farmData : { },
      
      sensorloading: false,
      weatherloading: false,
      shiploading: false,
      milkloading: false,
      marketloading: false,
      esgloading: false,
      energyloading: false,


      selectedTab:'전체',
      kind:'',
      kindEng:'',

      year:'',
      beforeYear:'',
      esgData:{ },

      nowYearco2:'',
      beforeYearco2:'',
      
      ratioco2:'',
      compareCo2:'',

      emissionData: {
        labels: [],
        datasets: []
      },
      emissionPerKgData: {
        labels: [],
        datasets: []
      },

      cost:[],
      wattitems:[],
      wattchartitems:[],
      wattChartData:{},
      
      lastWatt:'',
      nowWatt:'',

      compareWatt:'',
      ratioWatt:'',

      headers:[
        { value: "entity_no", text: "개체식별번호" },
        { value: "total_milking_wt", text: "착유량"},
        { value: "avg_mfat_rt", text: "유지방"},
        { value: "avg_mprt_rt", text: "유단백"},
      ],
      to_date:'',
      fr_date:'',

    }
  },
  async created(){
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    await this.typeSeriveUser();
    
    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 1));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    // if (this.farmData && this.farmData.code) {
    //   this.DairyMilkPerEntity(); 
    // }
  },
  methods:{
    farmInfo(data){
      this.farmData = data.farm;

      this.$emit('farmChanged', data);
      this.$store.commit('setFarmInfo', data);
      
      this.biz();
    },
    biz(){
      if(this.farmData.biz == 'CF02'){
        this.kind = '탕박'
        this.kindEng = 'pig'
      } else if(this.farmData.biz == 'CF05'){
        this.kind = '한우'
        this.kindEng = 'cattle'
      } else {
        this.kind = '육우'
        this.kindEng = 'cattle'
      }
    },
    selecShipTab(tab) {
      // console.log(tab)
      this.selectedShipTab = tab;
    },
    selectTab(tab) {
      this.selectedTab = tab;
    },
    async typeSeriveUser(){
      // if (this.$getters.isLogin) {
        await Apis.listAccesableServices({      // 제공 서비스 여부
           "farm_cd" : this.farmData.code
          },(res) => {
            this.services = res.data;
            // console.log(this.farmData)
            // console.log(this.services)
          }).catch( (err) => {  
            console.log("listAccesableServices API 호출 오류",err)
        })
      // }
    },
    refresh(){
      this.typeSeriveUser();
      this.farmSummary();
      this.weather();
      this.monthShipData();
      this.statisticsOfDairyMilkDaily()
      // this.DairyMilkPerEntity();
      this.infoMarket();
     

      if(this.farmData.no !==''){
        this.monitoringEsgValueOfFarm();
      }
     
      this.estimateAmountForEnergyPerMonth();
      this.wattData();
    },
    farmSummary(){
      this.sensorloading = true;

      Apis.farmSummaryViewForLite({
        farm_cd: this.farmData && this.farmData.code,
        building_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        this.items = res.data;
        // console.log(res.data);
        this.sensorloading = false;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("farmSummaryViewForLite 호출 오류",err);
        this.sensorloading = false;
      })
    },
    weather(){
      this.weatherloading = true;

      Apis.weatherForecast({
        farm_cd : this.farmData.code,
      },(res) => {  
        if (res.result) {
          this.current = res.data.current;
          this.forecast = res.data.forecast;

          this.weatherloading = false;
        } else {
         alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
        console.log("weatherForecast API 호출 오류",err)
        this.weatherloading = false;
      })
    },
    getdirection(item){
      return Common.getDirectionOnly(item);
    },
    getdirectionText(item){
      return Common.getDirection(item);
    },
    changeWeek(cdate){
      this.year = cdate.substring(0,4)

      const datePart = cdate.substring(0, 10);
      const date = new Date(datePart + "T00:00:00");

      const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

      const dayOfWeek = daysOfWeek[date.getDay()];

      // 월과 일을 2자리 숫자로 맞추기
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${month}.${day} ${dayOfWeek}`;

    },
    monthShipData(){
      this.$store.commit("resMessage","");
      this.shiploading = true;

      Apis.listSlaughterHeadOfFarmPerMonth({
        farmNo :this.farmData.no,
        to : dateUtil.format(new Date(), "yyyy-MM-dd"),
        months:6,
        kind : this.kindEng
      },(res) => {
        if (res.result) {
        this.monthItems = res.data;

        let date = [];
        let dataGrade = {};
        let allowedGrades;

        // 한우의 경우 표시할 등급 
        if(this.kindEng == 'pig'){
          allowedGrades = ["1+", "1", "2","etc"];
        }else if(this.kindEng == 'cattle' && this.selectedShipTab ==='qgrade'){
          allowedGrades = ["1++", "1+", "1", "2", "3"];
        }else if(this.kindEng == 'cattle' && this.selectedShipTab ==='wgrade'){
          allowedGrades = ["A", "B", "C", "D"];
        }
       

        allowedGrades.forEach((grade) => {
          dataGrade[grade] = [];
        });

        // 등급 있는거에 따라 데이터 처리
        this.monthItems.forEach((item) => {
          date.push(item.month);

          if(this.kindEng == 'pig'){
            // 값없으면 Null
            allowedGrades.forEach((grade) => {
              if (item[grade] !== undefined) {
                dataGrade[grade].push(item[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }else if(this.kindEng == 'cattle' && this.selectedShipTab ==='qgrade' ){
            allowedGrades.forEach((grade) => {
              if (item.qgrade[grade] !== undefined) {
                dataGrade[grade].push(item.qgrade[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }else if(this.kindEng == 'cattle' && this.selectedShipTab ==='wgrade' ){
            allowedGrades.forEach((grade) => {
              if (item.wgrade[grade] !== undefined) {
                dataGrade[grade].push(item.wgrade[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }
        });

        this.priceitems = {
          date,
          dataGrade,
        };

        this.lineChartData = this.drawChart();
        // console.log(this.chartitems)

        // this.$store.commit("resMessage",res.message);

        } else {
          alert(res.message);
        }
        this.shiploading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listSlaughterHeadOfFarmPerMonth API 호출 오류",err);
          this.shiploading = false;
      })
    },
    drawChart(){
      let allowedGrades = [];

      if (this.kindEng === 'pig') {
        allowedGrades = ["1+", "1", "2", "etc"];
      } else if (this.kindEng === 'cattle' && this.selectedShipTab === 'qgrade') {
        allowedGrades = ["1++", "1+", "1", "2", "3"];
      } else if (this.kindEng === 'cattle' && this.selectedShipTab === 'wgrade') {
        allowedGrades = ["A", "B", "C", "D"];
      }

      const gradeLabels = {
        "etc": "등외",
        "1+": "1+",
        "1": "1",
        "2": "2",
        "3": "3",
        "1++": "1++",
        "A": "A",
        "B": "B",
        "C": "C",
        "D": "D",
      };

      // const datasets = Object.keys(this.priceitems.dataGrade).map((grade, index) => {
      const datasets = allowedGrades.map((grade, index) => {
      const colors = [
        "rgb(0, 63, 107, 0.6)",
        "rgb(0, 91, 150, 0.6)",
        "rgb(42, 120, 200, 0.6)",
        "rgb(104, 164, 225, 0.6)",
        "rgb(180, 212, 245, 0.6)", 
      ];

      return {
          // label: grade,
          label: gradeLabels[grade] || grade,
          data: this.priceitems.dataGrade[grade] || [],
          backgroundColor: colors[index % colors.length],
          borderColor: colors[index % colors.length],
        };
      });

      return {
        labels: this.priceitems.date,
        datasets,
      };
    },
    // 착유 데이터 (통계)
    DairyMilkPerEntity(){
      this.milkloading = true;
      // console.log(this.farmData.code)
      Apis.statisticsOfDairyMilkPerEntity({
        "farm_cd" : this.farmData.code,
        "from" : this.fr_date,
        "to" : this.to_date
        },(res) => {  
        if (res.result) {
          // console.log(res.data)
          // this.Milkitems = res.data;
          this.Milkitems = res.data.map(item => ({
            ...item,
            entity_no:item.entity_no,
            total_milking_wt: item.result.total_milking_wt,
            avg_mfat_rt: item.result.avg_mfat_rt,
            avg_mprt_rt: item.result.avg_mprt_rt,
            avg_cond: item.result.avg_cond // 추가 속성
          }));

          this.milkloading = false;

        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("statisticsOfDairyMilkPerEntity API 호출 오류",err)
      })
    },
    // 착유 일별 데이터 (차트)
    statisticsOfDairyMilkDaily(){
      this.milkloading = true;

      Apis.statisticsOfDairyMilkDaily({
        "farm_cd" : this.farmData.code,
        "stand_date": dateUtil.format(new Date(), "yyyy-MM-dd"), 
        "day" : 31
        },(res) => {  
        if (res.result) {
          // console.log(res.data)
          this.Milkitems = res.data;

          let date = [];
          let total_cnt = [];
          let total_milk = [];

          this.Milkitems.forEach(function (item){
            // console.log(item)
            date.push(item.date.substring(5,16))|| date.push(null)
            if  (item.result.total_milking_cnt && !isNaN(item.result.total_milking_cnt)) total_cnt.push(item.result.total_milking_cnt)|| total_cnt.push(null)
            if  (item.result.total_milking_wt && !isNaN(item.result.total_milking_wt)) total_milk.push(item.result.total_milking_wt)|| total_milk.push(null)
          })


          this.milkData = {
            date: date,
            total_cnt:total_cnt,
            total_milk:total_milk
          }

          // console.log(this.milkData)
          this.milkChartData = this.drawmilkChart(); 
          this.milkloading = false;

        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("statisticsOfDairyMilkDaily API 호출 오류",err)
      })
    },
    
    drawmilkChart(){
      return{
        labels:this.milkData.date,
        datasets: [
          {
            type: "line",
            label: '착유횟수', 
            data:this.milkData.total_cnt,
            backgroundColor: 'rgba(111, 207, 151, 0.6)', 
            borderColor: 'rgba(111, 207, 151, 0.6)', 
            yAxisID: "y1",
          },
          {
            type: "bar",
            label: '착유량', 
            data:this.milkData.total_milk,
            backgroundColor: 'rgba(135, 206, 235, 0.3)', 
            borderColor: 'rgba(135, 206, 235, 0.3)', 
            yAxisID: "y2",
          },
        ]
      }
    },
    infoMarket(){
      this.marketloading = true;
      Apis.infoMarketRealTime({
        kind: this.kind
      },(res) => {  
        // console.log(res.data)
        this.result = res.resultCode;

        if (res.result) {
        this.market = res.data;
        this.liveinfo = res.data.amt_list;

        this.market.avg_amt = this.addCommas(this.market.avg_amt);
        this.market.cur_amt = this.addCommas(this.market.cur_amt);
        this.market.cur_fluct = this.addCommas(this.market.cur_fluct);
        this.market.max_amt = this.addCommas(this.market.max_amt);
        this.market.min_amt = this.addCommas(this.market.min_amt);
        this.market.start_amt = this.addCommas(this.market.start_amt);


        let hhmm = [];
        let auctAmt = [];
        let auctCnt = [];

        this.liveinfo.forEach(function (item){
          hhmm.push(item.hhmm)
          auctAmt.push(item.auctAmt)
          auctCnt.push(item.auctCnt)
        })

        this.marketData = {
          hhmm : hhmm,
          auctAmt : auctAmt,
          auctCnt : auctCnt
        }

        // this.refresh();
        this.doubleChart = this.marketdrawChart();

        // console.log("setTime",setTime);
        this.$store.commit("resMessage",res.message);

        this.marketloading = false;
      } else {
        alert(res.message);
      }
      }).catch( (err) => {  // API 오류 처리
          console.log("infoMarketRealTime API 호출 오류",err)
          this.marketloading = false;
      })
    },
    marketdrawChart(){
      return{
        labels:this.marketData.hhmm,
        datasets: [
          {
            type: "line",
            label: '실시간 가격', 
            data:this.marketData.auctAmt,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)', 
            yAxisID: "y1",
          },
          {
            type: "bar",
            label: '실시간 거래량', 
            data:this.marketData.auctCnt,
            backgroundColor: 'rgba(174, 196, 247, 0.3)', 
            borderColor: 'rgba(174, 196, 247, 0.3)', 
            yAxisID: "y2",
          },
        ]
      }
    },
    monitoringEsgValueOfFarm(){
      this.esgloading = true;

      Apis.monitoringEsgValueOfFarm2({
        farmNo :this.farmData.no,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-01"), 
        month:12,
        },(res) => {
          this.esgData = res.data;

          this.nowYearco2 = this.esgData.sel.intestinal.ch4.local * 28 + this.esgData.sel.excreta.ch4.local * 28 + this.esgData.sel.excreta.n2o.local * 265 + this.esgData.sel.energy.co2.local + this.esgData.sel.energy.ch4.local * 28 + this.esgData.sel.energy.n2o.local * 265 + this.esgData.sel.etc.ch4.local * 28 ;
          this.beforeYearco2 = this.esgData.beforeYear.intestinal.ch4.local * 28 + this.esgData.beforeYear.excreta.ch4.local * 28 + this.esgData.beforeYear.excreta.n2o.local * 265 + this.esgData.beforeYear.energy.co2.local + this.esgData.beforeYear.energy.ch4.local * 28 + this.esgData.beforeYear.energy.n2o.local * 265 + this.esgData.beforeYear.etc.ch4.local * 28 ; 
          
          const subCo2 = this.nowYearco2 - this.beforeYearco2;
          this.compareCo2 = parseInt(subCo2);

          const ratio = (this.nowYearco2 - this.beforeYearco2) / this.beforeYearco2 * 100
          this.ratioco2 = ratio.toFixed(1);
          

          this.chartEsg();

          this.esgloading = false;
        }).catch( (err) =>{
          console.log("monitoringEsgValueOfFarm2 API 호출 오류",err)
          this.esgloading = false;
        })
    },
    chartEsg(){
      if(this.selectedTab == '전체'){
        this.emissionData = this.YearAllData();
      }else{
        this.emissionPerKgData = this.KgAllData();
      }
    },
    YearAllData(){
      return{ 
        labels: [this.farmData.name], // 하나의 라벨로 묶음
        datasets: [
            {
                label: '장내발효', 
                data: [this.esgData.sel.intestinal.ch4.local * 28],
                backgroundColor: 'rgba(26, 33, 48, 0.6)',
                borderWidth: 1 
            },
            {
                label: '분뇨처리', 
                data: [this.esgData.sel.excreta.ch4.local * 28 + this.esgData.sel.excreta.n2o.local * 265], 
                backgroundColor: 'rgba(90, 114, 160, 0.6)', 
                borderWidth: 1 
            },
            {
                label: '에너지', 
                data: [this.esgData.sel.energy.co2.local + this.esgData.sel.energy.ch4.local * 28 + this.esgData.sel.energy.n2o.local * 265],  
                backgroundColor: 'rgba(131, 180, 255, 0.6)',
                borderWidth: 1 
            },
            // {
            //     label: 'etc', 
            //     data: [this.esgData.sel.etc.ch4.local * 28], 
            //     backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            //     borderWidth: 1 
            // },
        ],
      }
    },
    KgAllData(){
      return{
        labels: [this.farmData.name], 
        datasets: [
          {
            label: '장내발효',
            data: [this.esgData.sel_kg.intestinal.ch4.local*28], 
            backgroundColor: 'rgba(29, 93, 155, 0.6)',
            borderWidth: 1
          },
          {
              label: '분뇨처리', 
              data:[this.esgData.sel_kg.excreta.ch4.local*28 + this.esgData.sel_kg.excreta.n2o.local*265], 
              backgroundColor: 'rgba(117, 194, 246, 0.6)', 
              borderWidth: 1 
          },
          {
            label: '에너지', 
            data: [this.esgData.sel_kg.energy.co2.local + this.esgData.sel_kg.energy.ch4.local*28+ this.esgData.sel_kg.energy.n2o.local*265 ], 
            backgroundColor: 'rgba(244, 209, 96, 0.6)',
            borderWidth: 1
          },
          // {
          //   label: 'etc', 
          //   data: [this.esgData.sel_kg.etc.ch4.local * 28], 
          //   backgroundColor: 'rgba(90, 114, 160, 0.6)', 
          //   borderWidth: 1 
          // },
        ]
      }
    },
    estimateAmountForEnergyPerMonth(){
      this.energyloading = true;
      Apis.estimateAmountForEnergyPerMonth({
        kepcoNo: this.farmData.kepco || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
        this.cost = res.data;
      
        this.energyloading = false;
        this.$store.commit("resMessage",res.message);
      }).catch( (err) => {  // API 오류 처리
          console.log("estimateAmountForEnergyPerMonth API 호출 오류",err)
          this.energyloading = false;
      }) 
    },
    wattData(){
      this.energyloading = true;
      // console.log(this.farmData.kepco)
      Apis.accumulateWattPerDay({
        kepcoNo: this.farmData.kepco || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
      },(res) => {  
        this.wattitems = res.data;

        const newLocal = this;
        newLocal.wattchartitems = this.wattitems.map((item) => {
          // console.log(item)
          let beforeDate = [];
          let before_acc = [];
          let currentDate = [];
          let current_acc = [];
          let day = [];

          item.before.forEach((before) => {
            beforeDate.push(before.date);
            before_acc.push(before.acc);
            day.push(before.day);

            const matchDate = item.current.find(current => current.day === before.day);
            if (matchDate) {
              current_acc.push(matchDate.acc !== null && matchDate.acc !== undefined ? matchDate.acc : null);
            } else {
              current_acc.push(null);
            }

          });

          item.current.forEach((current) => {
            currentDate.push(current.date);
            current_acc.push(current.acc);
          });

          let nowAcc = item.current[item.current.length -1];
          this.nowWatt = nowAcc.acc;
          this.lastWatt = item.last_year;

          let compareWatt;
          let ratioWatt;

          if (this.nowWatt !== null && this.lastWatt !== null) {
            const subWatt = this.nowWatt - this.lastWatt;
            compareWatt = parseInt(subWatt);
            ratioWatt = ((this.nowWatt - this.lastWatt) / this.lastWatt * 100).toFixed(1);
          } else {
            compareWatt = "전년동월 사용량 없음";
            ratioWatt = "사용량 없음";
          }

          this.compareWatt = compareWatt;
          this.ratioWatt = ratioWatt;

          // const subWatt = this.nowWatt - this.lastWatt;
          // this.compareWatt = parseInt(subWatt);

          // const ratio = (this.nowWatt - this.lastWatt) / this.lastWatt * 100
          // this.ratioWatt = ratio.toFixed(1);

          return {
            compareWatt: this.compareWatt, 
            ratioWatt: this.ratioWatt,       
            day : day,
            beforeDate: beforeDate,
            before_acc: before_acc,
            currentDate: currentDate,
            current_acc: current_acc
          };
        });


        this.updateChartData();
        this.energyloading = false;

      }).catch( (err) => {  // API 오류 처리
          console.log("accumulateWattPerDay API 호출 오류",err)
          this.energyloading = false;
      })
    },
    updateChartData() {
    if (!Array.isArray(this.wattchartitems)) return;

    this.wattChartData = this.wattchartitems.map(item => {
      // console.log(item)
      return{
        labels: item.day.map(day => `${day}일`) ,

        datasets: [
          {
            type: 'line',
            label: '전월사용량',
            data: item.before_acc,
            yAxisID: 'y-axis-1',
            borderColor: '#ADC0F6',
            backgroundColor: "rgba(173, 192, 246, 0.4)",
          },
          {
            type: 'line',
            label: '당월사용량',
            data: item.current_acc,
            yAxisID: 'y-axis-1',
            borderColor: '#80BCBD',
            spanGaps: true,
              pointRadius: (ctx) => {
                // 데이터가 null 값이면 동글 포인트는 안해주는걸로
                const val = ctx.raw;
                return val?.isInterpolated ? 0 : 1;
              },
            backgroundColor: "rgba(128, 188, 189, 0.4)",
          }
          ],

          compareWatt: item.compareWatt || 0,  
          ratioWatt: item.ratioWatt || 0   
        }
      });
    },
    addCommas(num){
      if (typeof num === 'number') {
          return num.toLocaleString();
      }
      return num;
    },
    summary(){
      // console.log(this.farmData)
      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      this.$router.push({
        name: "Summary",
        params: { 
          company:{code: this.farmData.company_cd, name: this.farmData.company_name},
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    },
    weatherSite(){
      sessionStorage.setItem("weatherData",JSON.stringify(this.items));
      this.$router.push({
        name: "Weather",
        params: { 
          company:{code: this.farmData.company_cd, name: this.farmData.company_name},
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    },
    sell(){
      sessionStorage.setItem("sellData",JSON.stringify(this.items));
      this.$router.push({
        name: "Ship",
        params: { 
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    },
    milk(){
      sessionStorage.setItem("sellData",JSON.stringify(this.items));
      this.$router.push({
        name: "NewMilk",
        params: { 
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    },
    marketSite(){
      // alert('수정중')
      this.$router.push("/record/market")
    },
    esg(){
      // alert('수정중')

      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      this.$router.push({
        name: "Esg",
        params: { 
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    },
    energy(){
      // alert('수정중')

      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      this.$router.push({
        name: "Energy",
        params: { 
          farm:{code: this.farmData.code, name: this.farmData.name},
         }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../style/base.scss';
@import '../style/dash_mb.scss';

::v-deep .v-carousel {
  width: 100%; /* 부모 컨테이너의 너비에 맞추어 고정 */
  max-width: 100%; /* 최대 너비를 부모 크기로 제한 */
  overflow: hidden; /* 넘치는 내용을 가로로 스크롤 방지 */
  position: relative;
}
.center-align {
  justify-content: center;
}

.flex-start-align {
  justify-content: flex-start;
}
.base-loading-container{
  position: absolute; /* 스피너를 절대 위치로 설정 */
  top: 50%; /* 화면 중앙에 위치 */
  left: 50%; /* 화면 중앙에 위치 */
  transform: translate(-50%, -50%); /* 중앙 정렬 */
}
.loading-container{
  height:20vh;
}
.main-container {
  height: 90vh; 
}
.basic-container{
  height:35vh;
}
.dailyrecord-container, .esg-container  {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 28vh; 
  margin-top:5px;
}
.carousel{
  height:33vh !important;
}
.energy-carousel{
  min-height: 22vh !important; 
}
.energy-carousel .v-carousel__controls{
  margin-bottom: -10px !important;
}
.sensor, .weather, .sell, .market, .esg, .energy {
  background-color: white;
  margin-right: 5px;
  border-radius: 10px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 10px;
  height: 100%; /* 부모 컨테이너의 높이에 맞춤 */
  cursor: pointer;
}

.title{
  margin:5px;
}
.title_text{
  margin-left:5px;
  font-weight:600;
  letter-spacing: -0.25px;
}
.title_line{
  width:100%;
  height: 2px;
  border:1px solid $main-color;
}
.main-container {
  display: flex;
  flex-wrap: wrap; 
  justify-content: space-between;
}

.basic-container, .service-container {
  display: flex;
  width: 100%;
  justify-content: space-between; 
}

.sensor, .weather, .sell, .market, .esg, .energy{
  background-color:white;
  margin-right:5px;
  border-radius: 10px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  padding:10px;
}
.sensor {
  flex: 1 1 65%;
  max-width: 55vw; 
  min-width: 0 !important;
  position: relative;
  display: block;
}
.weather {
  flex: 1 1 35%;
}
.sell, .market, .esg, .energy {
  flex: 1 1 50%;
}
.sensor-container{
  height: 25vh;
}
.sensor_container {
  display: block;
  white-space: nowrap;
  text-align: center;
  overflow-x: auto;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: -0.5em; 
}

.room_info {
  display: inline-block;
  min-width: 110px;
  max-width: 110px;
  margin: 3px;
  background-color: $main-color;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(253, 251, 251, 0.8) 0%, #EBEDEE 100%);
  letter-spacing: 0;
  vertical-align: top;
  overflow: hidden;
}
.room_name{
  white-space: nowrap;
  font-weight: $bold-weight;
  line-height: 17px;
  text-align: center;
  color: white;
  background-color: $main-color;
  padding: 12px !important;
  border-radius: 10px 10px 0 0 !important;
  overflow: hidden;
  text-overflow: ellipsis; /* 텍스트가 넘치면 ...으로 생략 */
}
.room_text{
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; /* 넘치면 ...으로 생략 */
}
.time_text{
  font-size:0.7rem;
  font-weight:$bold-weight;
  letter-spacing: -1px;
  margin-right:5px;
  height:8px;
  font-weight:$semibold-weight;
  color:#AAAAAA;
}
.sensor_info_container {
  display: flex;
  align-items: center;
  justify-content: center; 
  min-height: 115px !important;
  max-height: 115px !important;
  line-height:1px;
  overflow: hidden; 
}
.sensor_info{
  padding: 10px;
  color: black;
  text-align: center;
}
.icon_size , .value_box{
  width:20px !important;
  height:18px !important;
  text-align: center;
  margin-right:10px;
}
.value{
  justify-content: space-between;
  align-items: center;
}
.value_text{
  max-width:40px !important; 
  min-width:40px !important;
  text-align: left !important;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -1px;
}
.unit{
  font-size:12px;
  width:15px;
}
.ppm{
  font-size:10px !important;
  letter-spacing: -1.25px;
}


// 날씨
.weather-container{
  height: 25vh;
  line-height: 15px;
  width: 100%; 
}
.current-container{
  border-radius: 30px;
  background: #FFFFFF;
  box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.25);
  display: flex; 
  width: 95%; /* 부모 요소의 80% 너비로 설정 */
  max-width:650px; /* 최대 너비를 제한하여 너무 커지지 않도록 */
  height: 55px;
  align-items: center;
  justify-content: space-evenly; /* 자식 요소들을 균등하게 배치 */
  margin: 0 auto; /* 가운데 정렬 */
}
.current-date{
  text-align: center;
  font-size:0.9rem;
  font-weight:$semibold-weight;
  min-width:10%;
}
.weather-icon{
  width: 2.5rem; /* 이미지 크기를 줄임 */
  height: 2.5rem; /* 이미지 크기를 명시적으로 지정 */
}

.weather-info{
  min-width:18%;
  justify-content: center;
  align-items: center;
}
.degree-content{
  min-width:15%;
  text-align: center;
}
.feel-content{
  min-width:12%;
  text-align: center;
}
.degree-content .cur_info{
  font-size:1.1rem;
  font-weight:$bold-weight;
}
.highlow_temp{
  font-size:0.8rem;
  letter-spacing: -1px;
  font-weight:$semibold-weight;
}
.small-text{
  font-size:$small-font !important;
  margin-right:5px;
}
.bold-text{
  font-weight:$bold-weight;
  font-size:13px !important;
}
.info_unit{
  vertical-align:top;
  font-size:0.7rem;
}

.forecast-container {
  width: 100%;
  max-width: 35vw; 
  overflow-x: hidden; 
}
.forecast-content {
  display: flex;
  justify-content: center; 
  width: 100%;
  overflow-x: hidden;
  margin-top: 1.0rem;
}

.forecast_info {
  border: 1px solid #005B96;
  box-shadow: 0px 0.5px 5px rgba(0, 0, 0, 0.25);
  border-radius: 7px;
  width:14%;
  margin-left:10px;
  height:100px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.date-text{
  font-weight:$bold-weight;
  font-size:0.9rem;
  letter-spacing: -1.25px;
}
.forecast_icon img{
  width:2.8rem;
  height:2.8rem;
}
.forecast_degree{
  display:flex;
  justify-content: center;
}
.degree_info{
  font-size:0.8rem !important;
  letter-spacing: -1px;
}
.wind-section{
  min-width:20%;
  justify-content: center;
}
.press-section{
  min-width:18%;
}
.press-content{
  justify-content: left;
}
.wind-content{
  align-items: center;
}
.wind-icon{
  width:20px;
  height:20px;
}
.wind-text{
  width:35px;
  text-align: left;
}
//착유
.table_layout{
  width:100% !important;
  height:20vh;
}
::v-deep .date_info{
  font-size:14px;
  letter-spacing: -1px;
  color:#a7a7a7;
}
// 시장
.sell-container ,.market-container, .ch4-container, .energy-container{
  height:20vh;
}

.chart__layout{
  width: 100%;
  margin-top:10px;
}
.market-info{
  width:100% !important;
  height:20vh !important;
  margin-top:10px;
}
.live-info{
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding:15px;
  width:25%;
  min-width:180px;
  display:flex;
  margin: 0 5px !important;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.marketcost-info{
  width:75%;
  padding:15px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}
.market_chart_layout{
  width:100%;
}
.market_title{
  font-size:$big-font;
  font-weight:$bold-weight;
}

.live_cost{
  font-size:1.5rem;
  font-weight:600;
}
.market_unit{
  font-size:0.7rem;
  letter-spacing: -1px;
}
.amt_info{
  font-size:0.95rem;
  font-weight:500;
}

// esg
.tab-container{
  justify-content:end;
  align-items: center;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height:35px;
  line-height: 24px;
}

.tab {
  flex: 1;
  width:60px;
  // padding:4px 30px;
  border-radius: 5px;
  border: none;
  background-color: #f5f5f5; /* 기본 배경색 */
  color: #A0A0A0; /* 기본 글자색 */
  font-size: 15px !important;
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: white; 
  color: #000;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #e0e0e0; 
}
.ch4-info{
  width:100%;
  align-items: center;
  justify-content: center;
}
.ch4-chart{
  margin-top:-30px !important;
}
.ch4-chart , .energy-chart{
  width:70%;
}
.esg-info{
  margin-top:-25px !important;
}
.cost-content, .esg-info{
  background-color: $menu-color;
  padding:5px 15px;
  border-radius: 5px;
}
.esg-title{
  font-size:1.0rem;
  letter-spacing: -1px;
}
.esg-value{
  font-weight: $bold-weight;
  font-size: 1.2rem;
  letter-spacing: -1px;
}
.kepco-number{
  font-size:0.8rem;
  letter-spacing: -1px;
  padding:5px;
}
// 에너지
.energy-info{
  // margin-top:40px;
}
.cost-info{
  // margin:10px;
}
.cost-font{
  font-size:0.95rem !important;
}
.weather-doll{
  // align-items: center
  // height:50px;
  margin-top:10px;
}
.value-weather{
  display: flex;
  flex-direction: column;
}
// 노트북 해상도
@media screen and (min-width: 769px) and (max-width: 1440px){
.dailyrecord-container, .esg-container  {
  height: 27vh; 
  margin-top:5px;
}
.sell-container ,.market-container, .ch4-container, .energy-container{
  height:17vh !important;
}
.energy-carousel{
  min-height: 180px !important;
  max-height: 180px !important; 
}
.market_chart_layout{
  height: 130px !important;
  margin-top:-10px;
}
.sensor_info_container {
  min-height: 105px !important;
  max-height: 105px !important;
}
  // 시장정보
.market_title{
  font-size:17px;
}
.live_cost{
  font-size:13px;
}
.live-info{
  min-width:160px;
  max-width:160px;
}
.market_unit{
  font-size:11px;
  letter-spacing: -1px;
}
.mb-text{
  font-size:13px !important;
}
.amt_info{
  font-size:13px;
}
.market-info{
  height:18.5vh !important;
  margin-top:20px !important;
}
.live-info{
  margin:0 5px;
  padding:10px;
}
.marketcost-info{
  padding:10px;
}
.esg-info{
  // margin-top:-35px !important;
}
.energy-info{
  margin-top:25px !important;
}
.ch4-chart , .energy-chart{
  width:60%;
}
.ch4-chart{
  // margin-top:-50px !important;
}

.esg-title{
  font-size:12px;
}
.cost-font{
  font-size:12px !important;
}
.esg-value{
  font-size: 14px !important; 
}
.kepco-number{
  display:none;
}
.ratio-mb{
  font-size:11px !important;
}
}


</style>